import { Session } from '@isaia/entity/session';

export function toSessionString(session: Session) {
  try {
    return JSON.stringify(session);
  } catch (e: any) {
    return `Unable to stringify session. Error: ${e?.message || e?.stack || e?.toString() || 'UNPARSABLE_ERROR'}`;
  }
}
